import React, { useContext, useState } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import jsDig from "utils/jsDig.js";
import CustomTooltip from "utils/CustomTooltip";
import showAlert from "utils/showAlert";
import LastDataPullStatus from "client_config/lite/LastDataPullStatus";
import GoogleAdsCustomConversions from "client_config/lite/GoogleAdsCustomConversions";
import GoogleAdsCampaignFilters from "client_config/lite/GoogleAdsCampaignFilters";
import MetaAdsCustomConversions from "./MetaAdsCustomConversions";

export default function AccountIds() {
  const context = useContext(SettingsContext);

  let shopifyIcon = require("images/lite/icons/shopify.png");
  let shopifyIconWhite = <img className="platform-icon shop-icon-white filter-white" src={`/datapulse${shopifyIcon}`} />;
  shopifyIcon = <img className="platform-icon" src={`/datapulse${shopifyIcon}`} />;
  let googleAds = require("images/lite/icons/google-ads.png");
  googleAds = <img className="platform-icon" src={`/datapulse${googleAds}`} />;
  let microsoftAds = require("images/lite/icons/microsoft-ads.png");
  microsoftAds = <img className="platform-icon" src={`/datapulse${microsoftAds}`} />;
  let metaAds = require("images/lite/icons/meta.png");
  metaAds = <img className="platform-icon" src={`/datapulse${metaAds}`} />;
  let tiktokAds = require("images/lite/icons/tiktok.png");
  tiktokAds = <img className="platform-icon" src={`/datapulse${tiktokAds}`} />;
  let GoogleAnalytics = require("images/lite/icons/google-analytics.png");
  GoogleAnalytics = <img className="platform-icon" src={`/datapulse${GoogleAnalytics}`} />;
  let searchConsoleIcon = require("images/lite/icons/search-console.png");
  searchConsoleIcon = <img className="platform-icon" src={`/datapulse${searchConsoleIcon}`} />;
  let semrush = require("images/lite/icons/semrush.png");
  semrush = <img className="platform-icon" src={`/datapulse${semrush}`} />;
  let amazonAdsIcon = require("images/lite/icons/amazon-icon.png");
  amazonAdsIcon = <img className="platform-icon" src={`/datapulse${amazonAdsIcon}`} />;
  let amazonSellerIcon = require("images/lite/icons/amazon-sc.png");
  amazonSellerIcon = <img className="platform-icon" src={`/datapulse${amazonSellerIcon}`} />;
  let googleSheetsIcon = require("images/lite/icons/google-sheets.png");
  googleSheetsIcon = <img className="platform-icon" src={`/datapulse${googleSheetsIcon}`} />;
  let mailchimpIcon = require("images/lite/icons/mailchimp.png");
  mailchimpIcon = <img className="platform-icon filter-grey" src={`/datapulse${mailchimpIcon}`} />;
  let pinterestIcon = require("images/lite/icons/pinterest.png");
  pinterestIcon = <img className="platform-icon filter-grey" src={`/datapulse${pinterestIcon}`} />;
  let klaviyoIcon = require("images/lite/icons/klaviyo.png");
  klaviyoIcon = <img className="platform-icon filter-grey" src={`/datapulse${klaviyoIcon}`} />;
  let refreshIcon = require("images/lite/icons/refresh.svg");
  refreshIcon = <img className="refresh-icon filter-grey" src={`/datapulse${refreshIcon}`} style={{ width: "30px" }} />;

  let microsoftExample = require("images/onboarding/microsoft-example.png");
  microsoftExample = <img className="pt-3" src={`/datapulse${microsoftExample}`} />;
  const microsoftMessage = <div>Account IDs must be taken from the URL. Select the account from the initial list of accounts, then check the url for the "aid" parameter. The account id directly follows the = symbol. {microsoftExample}</div>
  
  let pinterestExample = require("images/lite/icons/pinterestID.jpg");
  pinterestExample = <img className="pt-3" src={`/datapulse${pinterestExample}`} />;
  const pinterestMessage = <div>Account IDs must be taken from the URL. Select the account, then check the url for the number following between the slashes following "advertiser" in the url {pinterestExample}</div>

  const klaviyoMessage = <div>You need to create a private API key in Klaviyo. Log in and go to Settings {">"} Account {">"} API Keys. Create a new private API key and make sure to give <strong>Read access</strong> to all scopes.</div>

  let projectIdImg = require("images/semrush-project-id.jpg");
  projectIdImg = <img className="pt-3" src={`/datapulse${projectIdImg}`} />;
  const semrushExample = <div>The ID can change if a new target location has been selected. To make sure the ID is correct, open the project in SEMRush, and in the 'Position Tracking' tile, select 'View full report'. Copy the ID from the URL. {projectIdImg}</div>

  let googleSheetsUrlMessage = "Create a copy of the template link and input the performance data. Make sure view access to the spreadsheet is given to the account that authenticated with Google Sheets.";

  const [facebookObjective, setFacebookObjective] = useState(jsDig(["facebookObjective"], context) || '');
  const [tiktokObjective, setTiktokObjective] = useState(jsDig(["tiktokObjective"], context) || '');
  const [semrushTargetLocation, setSemrushTargetLocation] = useState(jsDig(["semrushTargetLocation"], context) || '');
  const [shopifyRevenueType, setShopifyRevenueType] = useState(jsDig(["shopifyRevenueType"], context) || '');
  const [shopifyCountryFilter, setShopifyCountryFilter] = useState(jsDig(["shopifyCountryFilter"], context) || '');
  const [googleAdsId, setGoogleAdsId] = useState(jsDig(["googleAdsId"], context) || '');
  const [microsoftId, setMicrosoftId] = useState(jsDig(["microsoftId"], context) || '');
  const [metaId, setMetaId] = useState(jsDig(["metaId"], context) || '');
  const [tiktokId, setTiktokId] = useState(jsDig(["tiktokId"], context) || '');
  const [googleAnalyticsId, setGoogleAnalyticsId] = useState(jsDig(["googleAnalyticsId"], context) || '');
  const [searchConsoleProperty, setSearchConsoleProperty] = useState(jsDig(["searchConsoleProperty"], context) || '');
  const [brandedRegex, setBrandedRegex] = useState(jsDig(["brandedRegex"], context) || '');
  const [semrushId, setSemrushId] = useState(jsDig(["semrushId"], context) || '');;
  const [amazonAdsId, setAmazonAdsId] = useState(jsDig(["amazonAdsId"], context) || '');
  const [amazonSellerCountry, setAmazonSellerCountry] = useState(jsDig(["amazonSellerCountry"], context) || '');
  const [shopifyUrl, setShopifyUrl] = useState(jsDig(["shopifyUrl"], context) || '');
  const [googleSheetsUrl, setGoogleSheetsUrl] = useState(jsDig(["googleSheetsUrl"], context) || '');
  const [mailchimpServerPrefix, setMailchimpServerPrefix] = useState(jsDig(["mailchimpServerPrefix"], context) || '');
  const [pinterestAdsId, setPinterestAdsId] = useState(jsDig(["pinterestAdsId"], context) || '');
  const [klaviyoApiKey, setKlaviyoApiKey] = useState(jsDig(["klaviyoApiKey"], context) || '');
  const [klaviyoConversionMetric, setKlaviyoConversionMetric] = useState(jsDig(["klaviyoConversionMetric"], context) || '');
  const [searchConsoleProperties, setSearchConsoleProperties] = useState(jsDig(["search_console_properties"], context) || []);
  const [amazonAdsProfileIds, setAmazonAdsProfileIds] = useState(jsDig(["amazon_profile_ids"], context) || []);
  const [klaviyoMetrics, setKlaviyoMetrics] = useState(jsDig(["klaviyo_metrics"], context) || []);
  const [metaAdsAttributionType, setMetaAdsAttributionType] = useState(jsDig(["metaAdsAttributionType"], context) || '');
  const [metaAdsCampaignFilter, setMetaAdsCampaignFilter] = useState(jsDig(["metaAdsCampaignFilter"], context) || '');
  const [shopifyRevenueMetric, setShopifyRevenueMetric] = useState(jsDig(["shopifyRevenueMetric"], context) || '');

  const handleRefreshIds = async (platform) => {
    let platformTitle = "";
    let updateIdsCallback = null;
    let route = "";

    if (platform == "search_console") {
      platformTitle = "Search Console";
      updateIdsCallback = setSearchConsoleProperties;
      route = "refresh-search-console-properties";
    } else if (platform == "amazon_ads") {
      platformTitle = "Amazon Ads";
      updateIdsCallback = setAmazonAdsProfileIds;
      route = "refresh-amazon-ads-profiles";
    } else if (platform == "klaviyo") {
      platformTitle = "Klaviyo";
      updateIdsCallback = setKlaviyoMetrics;
      route = "refresh-klaviyo-metrics";
    }

    const response = await fetch(`/datapulse/lite-config/${route}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      }
    });
    if (response.ok) {
      const data = await response.json();
      console.log(data);
      if (data.success) {
        updateIdsCallback(data.platform_ids);
        showAlert(`${platformTitle} IDs refreshed successfully`);
      } else {
        showAlert(`Failed to refresh ${platformTitle} IDs\n` + data.error);
      }
    }
  };
  
  // onChange handlers
  const handleFacebookObjectiveChange = (e) => {
    setFacebookObjective(e.target.value);
    context.setFacebookObjective(e.target.value);
  };
  const handleTiktokObjectiveChange = (e) => {
    setTiktokObjective(e.target.value);
    context.setTiktokObjective(e.target.value);
  };
  const handleSemrushTargetLocationChange = (e) => {
    setSemrushTargetLocation(e.target.value);
    context.setSemrushTargetLocation(e.target.value);
  };
  const handleShopifyRevenueTypeChange = (e) => {
    setShopifyRevenueType(e.target.value);
    context.setShopifyRevenueType(e.target.value);
  };
  const handleShopifyCountryFilterChange = (e) => {
    setShopifyCountryFilter(e.target.value);
    context.setShopifyCountryFilter(e.target.value);
  };

  const handleGoogleAdsIdChange = (e) => {
    const formattedId = phoneNumberAutoFormat(e.target.value);
    setGoogleAdsId(formattedId);
    context.setGoogleAdsId(formattedId);
  };
  const handleMicrosoftIdChange = (e) => {
    setMicrosoftId(e.target.value);
    context.setMicrosoftId(e.target.value);
  };
  const handleMetaIdChange = (e) => {
    setMetaId(e.target.value);
    context.setMetaId(e.target.value);
  };
  const handleTiktokIdChange = (e) => {
    setTiktokId(e.target.value);
    context.setTiktokId(e.target.value);
  };
  const handleGoogleAnalyticsIdChange = (e) => {
    setGoogleAnalyticsId(e.target.value);
    context.setGoogleAnalyticsId(e.target.value);
  };
  const handleSearchConsolePropertyChange = (e) => {
    setSearchConsoleProperty(e.target.value);
    context.setSearchConsoleProperty(e.target.value);
  };
  const handleBrandedRegexChange = (e) => {
    setBrandedRegex(e.target.value);
    context.setBrandedRegex(e.target.value);
  };
  const handleSemrushIdChange = (e) => {
    setSemrushId(e.target.value);
    context.setSemrushId(e.target.value);
  };
  const handleShopifyUrlChange = (e) => {
    setShopifyUrl(e.target.value);
    context.setShopifyUrl(e.target.value);
  };
  const handleAmazonAdsIdChange = (e) => {
    setAmazonAdsId(e.target.value);
    context.setAmazonAdsId(e.target.value);
  };
  const handleAmazonSellerCountryChange = (e) => {
    setAmazonSellerCountry(e.target.value);
    context.setAmazonSellerCountry(e.target.value);
  };
  const handleGoogleSheetsUrlChange = (e) => {
    setGoogleSheetsUrl(e.target.value);
    context.setGoogleSheetsUrl(e.target.value);
  };
  const handleMailchimpServerPrefixChange = (e) => {
    setMailchimpServerPrefix(e.target.value);
    context.setMailchimpServerPrefix(e.target.value);
  };
  const handlePinterestAdsIdChange = (e) => {
    setPinterestAdsId(e.target.value);
    context.setPinterestAdsId(e.target.value);
  };
  const handleKlaviyoApiKeyChange = (e) => {
    setKlaviyoApiKey(e.target.value);
    context.setKlaviyoApiKey(e.target.value);
  };
  const handleKlaviyoConversionMetricChange = (e) => {
    setKlaviyoConversionMetric(e.target.value);
    context.setKlaviyoConversionMetric(e.target.value);
  };
  const handleMetaAdsAttributionTypeChange = (e) => {
    setMetaAdsAttributionType(e.target.value);
    context.setMetaAdsAttributionType(e.target.value);
  };
  const handleMetaAdsCampaignFilterChange = (e) => {
    setMetaAdsCampaignFilter(e.target.value);
    context.setMetaAdsCampaignFilter(e.target.value);
  };
  const handleShopifyRevenueMetricChange = (e) => {
    setShopifyRevenueMetric(e.target.value);
    context.setShopifyRevenueMetric(e.target.value);
  };

  const phoneNumberAutoFormat = (phoneNumber) => {
    // First, check if input ends with a hyphen
    const endsWithHyphen = phoneNumber.endsWith("-");
    // Remove all non-numeric characters except for the trailing hyphen
    const number = phoneNumber.trim().replace(endsWithHyphen ? /[^0-9-]$/g : /[^0-9]/g, "");
  
    if (number.length < 4) return number;
    if (number.length === 4 && endsWithHyphen) return number.substring(0, 3) + '-';
    if (number.length < 7) return number.replace(/(\d{3})(\d+)/, "$1-$2");
    if (number.length < 11) return number.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");
    return number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  };

  const authenticateShopifyFunction = () => {
    const paramsObject = {
      shopify_url: shopifyUrl,
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify/get-permission-url",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(paramsObject),
      success: (data, success, xhr) => {
        window.open(data.permission_url, "_blank");
  
        // Change the button to red and update text to "Reset Token"
        const button = document.querySelector('.shopify-authentication button');
        button.classList.remove('btn-success');
        button.classList.add('btn-danger');
        button.innerHTML = `Reset Token<i class="fas fa-cog pl-2" style="padding-right: 0px; color: unset; float: unset;"></i>`;
        button.removeAttribute('onclick'); 
        button.onclick = resetShopifyToken; 
      },
    });
    console.log("Started Shopify authentication flow");
  };

  const resetShopifyToken = () => {
    let myObject = {
      shopify_token: "",
      client_account_id: context.client_account.id,
    };
    $.ajax({
      type: "POST",
      url: "/datapulse/shopify/reset-token",
      dataType: "json",
      async: false,
      contentType: "application/json",
      data: JSON.stringify(myObject),
      success: (data, success, xhr) => {
        const button = document.querySelector('.shopify-authentication button');
        button.classList.remove('btn-danger');
        button.classList.add('btn-success');
        button.innerHTML = `Authenticate<i class="fas fa-cog pl-2" style="padding-right: 0px; color: unset; float: unset;"></i>`;
        button.removeAttribute('onclick'); 
        button.onclick = authenticateShopifyFunction; 
      }
    });
    console.log("Reset Shopify authentication")
  };

  const amazonSellerCountries = [
    { name: "United States", value: "US" },
    { name: "Canada", value: "CA" },
    { name: "Mexico", value: "MX" },
    { name: "Brazil", value: "BR" },
    { name: "United Kingdom", value: "UK" },
    { name: "Germany", value: "DE" },
    { name: "France", value: "FR" },
    { name: "Italy", value: "IT" },
    { name: "Spain", value: "ES" },
    { name: "Netherlands", value: "NL" },
    { name: "Sweden", value: "SE" },
    { name: "Poland", value: "PL" },
    { name: "Turkey", value: "TR" },
    { name: "Australia", value: "AU" },
    { name: "Japan", value: "JP" },
    { name: "India", value: "IN" },
    { name: "Singapore", value: "SG" },
    { name: "United Arab Emirates", value: "AE" },
    { name: "Saudi Arabia", value: "SA" },
    { name: "Egypt", value: "EG" },
    { name: "South Africa", value: "ZA" },
    { name: "Belgium", value: "BE" },
  ];

  const authorizeAmazonSeller = () => {
    window.open(`/datapulse/amazon-seller/oauth/authorize?country=${amazonSellerCountry}&platform=amazon_seller`, "_blank");
    document.querySelector("#amazon-seller-reload-msg").style.display = "block";
  };

  const deauthorizeAmazonSeller = async (id, el) => {
    const response = await fetch(`/datapulse/amazon-seller/oauth/deauthorize`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ credential_id: id }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        el.closest(".amazon-seller-authentication").remove();
        showAlert("Amazon Seller deauthorized successfully");
      } else {
        showAlert("Failed to deauthorize Amazon Seller.\n" + data.error);
      }
    }
  };

  const pullGoogleSheetsData = async (e) => {
    const button = e.target;
    // disable the button and add a buffering icon
    button.disabled = true;
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Pulling data...';
    const response = await fetch(`/datapulse/lite-config/pull-google-sheets-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ client_account_id: context.client_account.id }),
    });
    if (response.ok) {
      const data = await response.json();
      console.log(data)
      if (data.success) {
        showAlert("Google Sheets data pulled successfully");
        button.innerHTML = "Pull data";
      } else {
        showAlert("Failed to pull Google Sheets data.\n" + data.message);
        button.innerHTML = "Pull data";
        button.disabled = false;
      }
    }
  }

  const deleteGoogleSheetsData = async () => {
    const response = await fetch(`/datapulse/lite-config/delete-google-sheets-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ client_account_id: context.client_account.id }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        showAlert("Google Sheets data deleted successfully");
      }
    }
  }

  const authorizeMailchimp = async () => {
    window.open(`/datapulse/mailchimp/oauth/authorize?platform=mailchimp`, "_blank");
    document.querySelector("#mailchimp-reload-msg").style.display = "block";
  }

  const deauthorizeMailchimp = async (id, el) => {
    const response = await fetch(`/datapulse/mailchimp/oauth/deauthorize`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ credential_id: id }),
    });
    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        showAlert("Mailchimp deauthorized successfully");
      } else {
        showAlert("Failed to deauthorize Mailchimp.\n" + data.error);
      }
    }
  }

  // Datapull error display
  const googleAnalyticsErrors = context.data_pull_errors.filter((error) => error.platform == "google_analytics");
  const searchConsoleErrors = context.data_pull_errors.filter((error) => error.platform == "search_console");
  const googleAdsErrors = context.data_pull_errors.filter((error) => error.platform == "google_ads");
  const microsoftAdsErrors = context.data_pull_errors.filter((error) => error.platform == "microsoft_ads");
  const metaAdsErrors = context.data_pull_errors.filter((error) => error.platform == "meta_ads");
  const tiktokAdsErrors = context.data_pull_errors.filter((error) => error.platform == "tiktok_ads");
  const semrushErrors = context.data_pull_errors.filter((error) => error.platform == "semrush");
  const shopifyErrors = context.data_pull_errors.filter((error) => error.platform == "shopify");
  const googleSheetsErrors = context.data_pull_errors.filter((error) => error.platform == "google_sheets");
  const amazonAdsErrors = context.data_pull_errors.filter((error) => error.platform == "amazon_ads");
  const amazonSellerErrors = context.data_pull_errors.filter((error) => error.platform == "amazon_seller");
  const mailchimpErrors = context.data_pull_errors.filter((error) => error.platform == "mailchimp");
  const pinterestErrors = context.data_pull_errors.filter((error) => error.platform == "pinterest_ads");
  const klaviyoErrors = context.data_pull_errors.filter((error) => error.platform == "klaviyo");
  
  return (
    <div className="lite-acc-id-container">
      <div className="grid-container">
        <div className={`grid-item google-analytics ${googleAnalyticsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {GoogleAnalytics} <p>Google Analytics</p>
            </div>
            <LastDataPullStatus platform="google_analytics" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">Google Analytics ID</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="To find your GA4 ID, select the profile in GA4, then go to Settings > Property details, then locate the 'PROPERTY ID' in the top right"
              inline={true}
            />
            <input
              type="text"
              id="googleAnalyticsId"
              name="google_analytics_id"
              value={googleAnalyticsId}
              onChange={handleGoogleAnalyticsIdChange}
            ></input>
          </div>
        </div>

        <div className={`grid-item search-console ${searchConsoleErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {searchConsoleIcon} <p>Search Console</p>
            </div>
            <LastDataPullStatus platform="search_console" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">Search Property </p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="Select a Search Console property to pull data from. If you don't see your property, click the refresh icon to update the list of properties"
              inline={true}
            />
            <div className="d-flex" style={{ alignItems: "center", gap: "4px" }}>
              <div className="select-wrapper" style={{width: "100%" }}>
                <select id="searchConsoleProperty" name="search_console_property" value={searchConsoleProperty} onChange={handleSearchConsolePropertyChange}>
                  <option value="">None</option>
                  {searchConsoleProperties.map((site) => {
                    return (
                      <option key={site} value={site}>
                        {site}
                      </option>
                    );
                  })}
                </select>
              </div>
              <span onClick={() => handleRefreshIds("search_console")} style={{ cursor: "pointer" }}>
                <CustomTooltip
                  img={refreshIcon}
                  message="Click to refresh the list of Search Console Properties"
                  inline={true}
                />
              </span>
            </div>
          </div>
          <div className="bot-input-field">
            <p className="input-label d-inline-block">Branded Regex</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message={
                <>
                  Use this to instruct DataPulse what your branded keywords are for the Organic Search dashboard.
                  <br />
                  <code>.*digital position.*|.*positions.*|.*pisitions.*</code>
                  This regex will match any text containing "digital position," "positions," or "pisitions," with each pattern separated by a pipe (|) and beginning and ending with .* to allow for any characters before or after each keyword.
                </>
              }
              inline={true}
            />
            <input
              type="text"
              id="brandedRegex"
              name="branded_regex"
              value={brandedRegex}
              onChange={handleBrandedRegexChange}
             ></input>
          </div>
        </div>

        <div className={`grid-item google-ads ${googleAdsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {googleAds} <p>Google Ads</p>
            </div>
            <LastDataPullStatus platform="google_ads" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">Google Ads ID</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="To find your Google Ads ID, select the account in Google Ads, then locate the number that appears in the account picker in this format: 111-222-3333"
              inline={true}
            />
            <input
              type="text"
              maxLength="12"
              id="googleAdsId"
              name="google_ads_id"
              value={googleAdsId}
              onChange={handleGoogleAdsIdChange}
             ></input>
            <div className="google-ads-conversion-actions">
              <GoogleAdsCustomConversions />
            </div>
            <div className="google-ads-campaign-filter-actions">
              <GoogleAdsCampaignFilters />
            </div>
          </div>
        </div>
        <div className={`grid-item microsoft-ads ${microsoftAdsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {microsoftAds} <p>Microsoft Ads</p>
            </div>
            <LastDataPullStatus platform="microsoft_ads" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Microsoft Ads ID
            </p>
            <CustomTooltip  
              className="d-inline"
              faClass="far fa-question-circle pl-2"
              message= {microsoftMessage}
              style={{display: "inline"}}
              inline={true}
            /> 
            <input
              type="text"
              id="microsoftId"
              name="microsoft_id"
              value={microsoftId}
              onChange={handleMicrosoftIdChange}
            ></input>
          </div>
        </div>
        <div className={`grid-item meta-ads ${metaAdsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {metaAds} <p>Meta Ads</p>
            </div>
            <LastDataPullStatus platform="meta_ads" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">Meta Ads ID</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="To find your Meta Ads ID, select the profile in Meta Ads Manager, then locate the 'act' parameter in the URL. The account ID is the number following the = sign"
              inline={true}
            />
            <input type="text" id="metaId" name="meta_id" value={metaId} onChange={handleMetaIdChange}></input>
          </div>
          <div className="bot-input-field">
            <div className="bottom-label">
              <span className="input-label">Facebook Objective</span>
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message="Here you can set the objective for Meta conversions. Choose one of the pre-made settings from the dropdown, or use the custom conversions option to be more specific and input your own conversion IDs and labels (labels are simply to make your IDs easier to identify within DataPulse)."
                inline={true}
                />
            </div>
            <div className="select-wrapper">
              <select name="facebook_conversion_objective" value={facebookObjective} onChange={handleFacebookObjectiveChange}>
                {Object.keys(context.facebook_conversion_objectives).map((objectiveName) => {
                  const objectiveInt = context.facebook_conversion_objectives[objectiveName];
                  return (
                    <option key={objectiveInt} value={objectiveName}>
                      {objectiveName.split("_").join(" ").replace(/^\w/, (c) => c.toUpperCase())}
                    </option>
                  );
                })}
              </select>
            </div>
            {
            facebookObjective === "custom_conversions" &&
              <div className="meta-ads-conversion-actions">
              <MetaAdsCustomConversions />
            </div>
            }
            <div className="bottom-label mt-2">
              <span className="input-label">Attribution Setting</span>
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message="Choose which attribution type to use for calculating conversions & revenue. The default is 'campaign_default', which uses the attribution setting in Meta Ads Manager. '7d click' will attribute conversions to the last click within 7 days, and '7d click 1d view' will attribute conversions to the last click within 7 days and the last view within 1 day."
                inline={true}
                />
            </div>
            <div className="select-wrapper">
              <select name="meta_ads_attribution_type" value={metaAdsAttributionType} onChange={handleMetaAdsAttributionTypeChange}>
                {["campaign_default", "7d_click", "7d_click_1d_view"].map((attType, index) => {
                  return (
                    <option key={index} value={attType}>
                      {attType.split("_").join(" ").replace(/^\w/, (c) => c.toUpperCase())}
                    </option>
                  );
                })}
              </select>
            </div>
            <p className="input-label d-inline-block mt-2">Meta Ads Campaign Filter</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="Add a value here if you want to only include data from campaigns that contain a string in the name. Leave blank to include all (default)."
              inline={true}
            />
            <input type="text" id="metaAdsCampaignFilter" name="meta_ads_campaign_filter" value={metaAdsCampaignFilter} onChange={handleMetaAdsCampaignFilterChange} placeholder="Leave blank to include all"></input>
          </div>
        </div>
        <div className={`grid-item tik-tok-ads ${tiktokAdsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {tiktokAds} <p>TikTok Ads</p>
            </div>
            <LastDataPullStatus platform="tiktok_ads" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">TikTok Ads ID</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="To find your TikTok Ads ID, select the profile in TikTok Ads Manager, then locate the 'aadvid' parameter in the URL. The account ID is the number following the = sign"
              inline={true}
            />
            <input type="text" id="tiktokId" name="tiktok_id" value={tiktokId} onChange={handleTiktokIdChange}></input>
          </div>
          <div className="bot-input-field">
            <div className="bottom-label">
              <span className="input-label">TikTok Objective</span>
              <CustomTooltip
                  faClass="far fa-question-circle pl-2"
                  message="Choose which objective the Tiktok campaigns are targeting, typically 'Complete payment' for e-commerce and 'Complete registration' for Lead generation."
                  inline={true}
                />
            </div>
            <div className="select-wrapper">
              <select name="tiktok_conversion_objective" value={tiktokObjective} onChange={handleTiktokObjectiveChange}>
                {Object.keys(context.tiktok_conversion_objectives).map((objectiveName) => {
                  const objectiveInt = context.tiktok_conversion_objectives[objectiveName];
                  return (
                    <option key={objectiveInt} value={objectiveName}>
                      {objectiveName.split("_").join(" ").replace(/^\w/, (c) => c.toUpperCase())}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div className={`grid-item semrush ${semrushErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {semrush} <p>SEMRush</p>
            </div>
            <LastDataPullStatus platform="semrush" />
          </div>
          <div className="top-input-field">
            <p className="d-inline-block input-label">SEMRush ID</p>
            <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message={semrushExample}
                inline={true}
              />
            <input type="text" name="semrush_id" value={semrushId} onChange={handleSemrushIdChange}></input>
          </div>
          <div className="bot-input-field">
            <p className="input-label">SEMRush Target Location:</p>
            <div className="select-wrapper">
              <select name="semrush_target_location" value={semrushTargetLocation} onChange={handleSemrushTargetLocationChange}>
                <option disabled hidden>
                  Target Location
                </option>
                <option value="local">Local</option>
                <option value="regional">Regional</option>
                <option value="national">National</option>
              </select>
            </div>
          </div>
        </div>
        <div className={`grid-item shopify ${shopifyErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {shopifyIcon} <p>Shopify</p>
            </div>
            <LastDataPullStatus platform="shopify" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Shopify URL
            </p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="To find your shopify URL, log in to the account, go to Settings > Domains and locate the domain containing 'myshopify.com'"
              inline={true}
            />
            <input type="text" id="shopifyUrl" name="shopify_url" value={shopifyUrl} onChange={handleShopifyUrlChange}></input>
          </div>
          <div className="mid-input-field">
            <p className="input-label-2">Sales channel filter</p>
            <div className="radio-buttons-1">
              <input
                name="shopify_revenue_type"
                value="online_store"
                type="radio"
                id="shopify_revenue_type_0"
                checked={shopifyRevenueType === "online_store"}
                onChange={handleShopifyRevenueTypeChange}
              />
              <label htmlFor="shopify_revenue_type_0">Online Store Sales Only</label>
            </div>
            <div className="radio-buttons-2">
              <input
                name="shopify_revenue_type"
                value="overall"
                type="radio"
                id="shopify_revenue_type_1"
                checked={shopifyRevenueType === "overall"}
                onChange={handleShopifyRevenueTypeChange}
              />
              <label htmlFor="shopify_revenue_type_1">All Sales Channels</label>
            </div>
          </div>
          <div className="bot-input-field row-to-col gap-24">
            <div>
              <p className="input-label">Shopify Country Filter</p>
              <div className="select-wrapper mb-3">
                <select name="shopify_country_filter" value={shopifyCountryFilter} onChange={handleShopifyCountryFilterChange}>
                  {["none", "US", "CA"].map((country) => {
                    return (
                      <option key={country} value={country}>
                        {country === "none" ? "None (pull everything)" : country}
                      </option>
                    );
                  })}
                </select>
              </div>
              <p className="input-label d-inline-block">
                Shopify Revenue Metric
              </p>
              <CustomTooltip
                faClass="far fa-question-circle pl-2"
                message="You can select subtotal (default) or total to pull the revenue metric from Shopify"
                inline={true}
              />
              <div className="select-wrapper mb-3">
                <select name="shopify_revenue_metric" value={shopifyRevenueMetric} onChange={handleShopifyRevenueMetricChange}>
                  {["subtotal", "total"].map((metric) => {
                    return (
                      <option key={metric} value={metric}>
                        {metric.charAt(0).toUpperCase() + metric.slice(1)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            {jsDig(["shopify_token"], context.client_account) ? (
              <div className="shopify-authentication">
                <button type="button" className="lite-btn btn-danger auth-button" onClick={resetShopifyToken}>
                  Reset Token
                  <CustomTooltip faClass="far fa-question-circle f18 pl-2" message={"Resetting Shopify token will require you to authenticate again"} inline={true} />
                </button>
              </div>
            ) : (context.client_account.shopify_url && context.client_account.shopify_url != "") ? (
              <div className="shopify-authentication">
                <button type="button" className="lite-btn btn-success auth-button"  onClick={authenticateShopifyFunction}>
                  Authenticate
                  <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
                </button>
              </div>
            ) : (
              <div className="shopify-authentication">
                <p>Shopify URL required to authenticate</p>
              </div>
            )}
          </div>
        </div>
        <div className={`grid-item google-sheets ${googleSheetsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {googleSheetsIcon} <p>Google Sheets</p>
            </div>
            <LastDataPullStatus platform="google_sheets" />
          </div>
          <div className="top-input-field">
            <p><small>Can be used in place of Shopify or Google Analytics for total website conversions, revenue and new customers metrics</small></p>
            <p><small><a href="https://docs.google.com/spreadsheets/d/1_pwmMmoaFKk9C8dr1eTduvN-bOnHVC_d94BYocDaK1E/edit#gid=0" target="_blank">Template link</a></small></p>
            <p className="input-label mt-2 d-inline-block">Spreadsheet URL:</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message={googleSheetsUrlMessage}
              inline={true}
            />
            <input type="text" id="googleSheetsUrl" name="google_sheets_url" value={googleSheetsUrl} onChange={handleGoogleSheetsUrlChange}></input>
          </div>
          <div className="mid-input-field">
            <div className="mb-2 d-flex gap-12">
              <button type="button" className="lite-btn btn-success text-center" onClick={(e) => pullGoogleSheetsData(e)}>
                Pull data
              </button>
              <button type="button" className="lite-btn text-center btn-danger" onClick={(e) => deleteGoogleSheetsData()}>
                Delete data
                <CustomTooltip
                  faClass="text-white far fa-question-circle f18 pl-2"
                  message={`Press this button to delete all imported Google sheets data for this client.`}
                  inline={true}
                />
              </button>
            </div>
          </div>
        </div>
        <div className={`grid-item amazon-ads ${amazonAdsErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {amazonAdsIcon} <p>Amazon Ads</p>
            </div>
            <LastDataPullStatus platform="amazon_ads" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">Amazon Ads ID</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message="Select your Amazon Ads profile from the list below. If you don't see your profile, click the refresh icon to update the list of profiles"
              inline={true}
            />
            <p className="mb-3">Please select an account from the list below</p>
            <div className="d-flex" style={{ alignItems: "center", gap: "4px" }}>
              <div className="select-wrapper" style={{width: "100%" }}>
                <select id="amazonAdsId" name="amazon_ads_id" value={amazonAdsId} onChange={handleAmazonAdsIdChange}>
                  <option value="">None</option>
                  {amazonAdsProfileIds.map((id) => {
                    return (
                      <option key={id["id"]} value={id["id"]}>
                        {`${id["name"]} - ${id["country"]} - ${id["id"]}`}
                      </option>
                    );
                  })}
                </select>
              </div>
              <span onClick={() => handleRefreshIds("amazon_ads")} style={{ cursor: "pointer" }}>
                <CustomTooltip
                  img={refreshIcon}
                  message="Click to refresh the list of Amazon Ads profiles"
                  inline={true}
                />
              </span>
            </div>
          </div>
        </div>
        <div className={`grid-item amazon-seller ${amazonSellerErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {amazonSellerIcon} <p>Amazon Seller Central</p>
            </div>
            <LastDataPullStatus platform="amazon_seller" />
          </div>
          <div className="top-input-field">
            <p className="input-label">Select the country you would like to authenticate with:</p>
            <div className="row-to-col justify-content-space-between mb-3 gap-24">
              <div className="select-wrapper mb-3">
                <select id="amazonSellerCountry" name="amazon_seller_country" value={amazonSellerCountry} onChange={handleAmazonSellerCountryChange}>
                  {amazonSellerCountries.map((country) => {
                    return (
                      <option key={country.value} value={country.value}>
                        {`(${country.value}) - ${country.name}`}
                      </option>
                    );
                  })}
                </select>
              </div>
              <button type="button" className="lite-btn btn-success" onClick={() => authorizeAmazonSeller()}>
                Authenticate
                <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
              </button>
            </div>
            <div className="reload-msg" id="amazon-seller-reload-msg">
              <p>If authentication was successful you will see it on this page when you reload.</p>
            </div>
          </div>
          <div className="mid-input-field">
            <p className="input-label-2">
              <b>Current Authentications:</b>
            </p>
            {context.amazon_seller_credentials.map((cred) => {
              return (
                <div className="amazon-seller-authentication lite-flexbox justify-content-space-between mb-2" key={cred["id"]}>
                  <p>
                    {`${cred["country"]}`} - <b>{`${jsDig(["platform_ids", `amazon_seller_${cred["country"]}`], context.client_account)}`}</b>
                  </p>
                  <button type="button" className="lite-btn text-center btn-danger" onClick={(e) => deauthorizeAmazonSeller(cred["id"], e.target)}>
                    Deauthorize
                    <CustomTooltip
                      faClass="text-white far fa-question-circle f18 pl-2"
                      message={`If you deauthorize you will need to reauthorize before you can pull data from this country again.`}
                      inline={true}
                    />
                  </button>
                </div>
              );
            })}
            {context.amazon_seller_credentials.length === 0 && <p>None</p>}
          </div>
        </div>
        <div className={`grid-item mailchimp ${mailchimpErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {mailchimpIcon} <p>Mailchimp</p>
            </div>
            <LastDataPullStatus platform="mailchimp" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Server prefix:
            </p>
            <CustomTooltip
              faClass="far fa-question-circle f18 pl-2"
              message={`The server prefix is the subdomain of your Mailchimp account. For example, if your Mailchimp account is located at "https://us20.admin.mailchimp.com/", then your server prefix is "us20".`}
              inline={true}
            />
            <input type="text" id="mailchimpServerPrefix" name="mailchimp_server_prefix" value={mailchimpServerPrefix} onChange={handleMailchimpServerPrefixChange}></input>
            <div className="reload-msg" id="mailchimp-reload-msg">
              <p>If authentication was successful you will see it on this page when you reload.</p>
            </div>
          </div>
          <div className="mid-input-field">
            <div className="mb-2 d-flex gap-24">
              {context.mailchimp_credentials.map((cred) => {
                return (
                  <button key={cred["id"]} type="button" className="lite-btn text-center btn-danger" onClick={(e) => deauthorizeMailchimp(cred["id"], e.target)}>
                    Deauthorize
                    <CustomTooltip
                      faClass="text-white far fa-question-circle f18 pl-2"
                      message={`If you deauthorize you will need to reauthorize before you can pull data from Mailchimp again.`}
                      inline={true}
                    />
                  </button>
                );
              })}
              {context.mailchimp_credentials.length === 0 && (
                <button type="button" className="lite-btn btn-success" onClick={() => authorizeMailchimp()}>
                  Authenticate
                  <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className={`grid-item klaviyo ${klaviyoErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {klaviyoIcon} <p>Klaviyo</p>
            </div>
            <LastDataPullStatus platform="klaviyo" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">
              Klaviyo Private API KEY
            </p>
            <CustomTooltip  
              className="d-inline"
              faClass="far fa-question-circle pl-2"
              message= {klaviyoMessage}
              style={{display: "inline"}}
              inline={true}
            /> 
            <input
              type="text"
              id="klaviyoApiKey"
              name="klaviyo_api_key"
              value={klaviyoApiKey}
              onChange={handleKlaviyoApiKeyChange}
            ></input>
          </div>
          <div className="mid-input-field">
            <div className="bottom-label">
              <span className="input-label">Klaviyo Conversion Objective</span>
              <CustomTooltip
                  faClass="far fa-question-circle pl-2"
                  message="Choose which metric will be used to calculate conversions and revenue from Klaviyo. Typically 'Placed Order' for e-commerce and 'Submitted Form' for Lead generation. If you don't see your metric, click the refresh icon to update the list of metrics"
                  inline={true}
                />
            </div>
            <div className="d-flex" style={{ alignItems: "center", gap: "4px" }}>
              <div className="select-wrapper" style={{width: "100%" }}>
                <select name="klaviyo_conversion_metric" value={klaviyoConversionMetric} onChange={handleKlaviyoConversionMetricChange}>
                  <option value="">None</option>
                  {klaviyoMetrics.map((metric) => {
                    return (
                      <option key={metric["id"]} value={`${metric["id"]}|${metric["name"]}`}>
                        {metric["name"]}
                      </option>
                    );
                  })}
                </select>
              </div>
              <span onClick={() => handleRefreshIds("klaviyo")} style={{ cursor: "pointer" }}>
                <CustomTooltip
                  img={refreshIcon}
                  message="Click to refresh the list of Klaviyo Metrics"
                  inline={true}
                />
              </span>
            </div>
          </div>
        </div>
        <div className={`grid-item pinterest ${pinterestErrors.length > 0 ? "data-pull-error-bg" : ""}`}>
          <div className="d-flex justify-content-space-between">
            <div className="grid-item-header">
              {pinterestIcon} <p>Pinterest</p>
            </div>
            <LastDataPullStatus platform="pinterest_ads" />
          </div>
          <div className="top-input-field">
            <p className="input-label d-inline-block">Pinterest Account ID</p>
            <CustomTooltip
              faClass="far fa-question-circle pl-2"
              message= {pinterestMessage}
              inline={true}
            />
            <input
              type="text"
              id="pinterestAdsId"
              name="pinterest_ads_id"
              value={pinterestAdsId}
              onChange={handlePinterestAdsIdChange}
            ></input>
          </div>
        </div>
      </div>
    </div>
  );
}
